export enum SaleLotCategoryColors {
    None = "Gray",
    Blue = "Blue",
    Red = "Red",
    Yellow = "Yellow",
    Green = "Green"
}

export type SaleLotCategory = {
    id: number,
    name: string,
    color: string,
    description: string
}

export const DefaultSaleLotCategory: SaleLotCategory = {
    id: 0,
    name: '',
    color: SaleLotCategoryColors.None,
    description: ''
}

export type SaleDataLotCategories = {
    categories: SaleLotCategoryIndex
}

export type SaleLotCategoryIndex = {
    [lotCategoryId: number]: SaleLotCategory
}